import { FC, useState } from 'react'

import ArrowDefaultIcon from 'images/sorting-icon/icon-arrow-default.svg'
import ArrowUpIcon from 'images/sorting-icon/icon-arrow-up.svg'
import ArrowDownIcon from 'images/sorting-icon/icon-arrow-down.svg'
import ArrowUpHoverIcon from 'images/sorting-icon/icon-arrow-up-hover.svg'
import ArrowDownHoverIcon from 'images/sorting-icon/icon-arrow-down-hover.svg'

import { SortingStates } from '../types'

interface Props {
  className?: string
  sortingState?: SortingStates
  selected?: boolean
}

const SortingButton: FC<Props> = ({ className, sortingState, selected }) => {
  const [hovered, setHovered] = useState(false)
  let icon = ArrowDefaultIcon

  switch (sortingState) {
    case SortingStates.NotSort:
      icon = hovered ? ArrowUpHoverIcon : ArrowDefaultIcon
      break
    case SortingStates.AscendingOrder:
      icon = hovered ? ArrowDownHoverIcon : ArrowUpIcon
      break
    case SortingStates.DescendingOrder:
      icon = hovered ? ArrowDefaultIcon : ArrowDownIcon
      break
    default:
      break
  }

  const handleMouseEnter = () => {
    if (selected) {
      setHovered(false)
    } else {
      setHovered(true)
    }
  }

  const handleMouseLeave = () => {
    setHovered(false)
  }

  return (
    <img
      src={icon}
      className={className}
      alt="Sorting Icon"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    />
  )
}

export default SortingButton
